import { type FirebaseApp, getApps, initializeApp } from 'firebase/app'

export const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
	appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

export const isFirebaseConfigured = Boolean(
	firebaseConfig.apiKey &&
		firebaseConfig.projectId &&
		firebaseConfig.messagingSenderId &&
		firebaseConfig.appId &&
		import.meta.env.VITE_FIREBASE_VAPID_KEY,
)

export function getFirebaseApp(): FirebaseApp {
	return getApps()[0] ?? initializeApp(firebaseConfig)
}
